import { t } from "i18next";
import { Button } from "@/components/ui/button";
import type { StripeCustomerSession } from "@/common/types/stripe";

interface Props {
  stripeSession: StripeCustomerSession;
}

export const SetupSubscription = (props: Props): JSX.Element => {
  return (
    <div className="space-y-6">
      <div>
        <p>{t("settings.subscription.setupSubscriptions.clickOnTheButton")}</p>
        <p>
          {t(
            "settings.subscription.setupSubscriptions.oncePaymentIsSuccessful"
          )}
        </p>
      </div>
      <Button
        onClick={() =>
          window.open(props.stripeSession.url, "_blank", "noopener,noreferrer")
        }
      >
        {t("settings.subscription.setupSubscriptions.manageButton")}
      </Button>
    </div>
  );
};
